import {TokenExpiredError} from "@/lib/errors";

export function ErrorHandler(err, vm, info) {
    if (err instanceof TokenExpiredError) {
        // ignore
        return;
    }
    throw err;
}
